import Vue from "vue";
import swal from 'sweetalert2'
import router from "../router";
import axios from "axios";
import qs from "qs";
import NProgress from "nprogress";
import cookie from "js-cookie";
import VueSweetalert2 from '../plugins/vue-sweetalert2'
import { Loading, Message, MessageBox } from "element-ui";
//样式文件，需单独引入
import "element-ui/lib/theme-chalk/index.css";

import { BaseOssUrlDemo, BaseUrlOld, BaseUrlNew } from "./NewSiteUrl";

Vue.prototype.$http = axios;
// Vue.prototype.$notifynotify = Notification;
Vue.prototype.$loading = Loading;
Vue.prototype.$message = Message;
Vue.prototype.$swal = swal;
Vue.prototype.$qs = qs;

    // const BaseUrl = 'https://www.taozhuanr.com'; // 正式 正式 正式
    // const BaseUrl = 'https://www.taozhuanr.com:8018'; // 影子环境
    const BaseUrl = BaseUrlOld; // 测试 测试 测试
    localStorage.BaseUrl = BaseUrlOld
    

    /* oss 上传视频 */
    // const BaseOssUrl = 'https://taozhuanr-real.oss-cn-beijing.aliyuncs.com'; // 正式环境-正式环境-正式环境
    // const BaseOssUrl = 'https://taozhuanr-staging.oss-cn-beijing.aliyuncs.com'; // 影子环境
    // const BaseOssUrl = BaseOssUrlDemo; // 开发环境
    localStorage.BaseOssUrl = BaseOssUrlDemo
    localStorage.api2cs = BaseUrlNew
    // 加载数据时打开和关闭动效对象
    const loading = {//创建loading对象，在里面添加属性和方法，在方法中调用service添加配置
        LoadingInstance: null,//Loading对象实例，通过它作为判断条件.
        /* loadingService实例是常驻的，每次调用需要将之前的loading释放或置空，每次使用时创建新的 */
        open: function () {//生成loading实例，将遮罩层打开
            if (this.LoadingInstance === null) {
                // 创建单例, 防止切换路由重复加载
                this.LoadingInstance = Loading.service({
                    text: '正在导出',
                    // background: 'rgba(0, 0, 0, 0.8)',// 加载效果
                    target: document.querySelector('#table')// 效果显示区域 loadin覆盖的dom元素节点
                    /* 	Loading 需要覆盖的 DOM 节点。可传入一个 DOM 对象或字符串；
                    若传入字符串，则会将其作为参数传入 document.querySelector以获取到对应 DOM 节点 
                    这里找到AppMain组件*/
                })
            }
        },
        close: function () {//关闭loading实例，将实例对象置空
            if (this.LoadingInstance !== null) {
                this.LoadingInstance.close();//关闭遮罩层
            }
            this.LoadingInstance = null;//调用关闭方法，不能置空，需要手动置空
        }
    }
// 环境设置
// 环境的切换
// if (process.env.NODE_ENV == "development") {
//     axios.defaults.baseURL = BaseUrl;
// } else if (process.env.NODE_ENV == "debug") {
//     axios.defaults.baseURL = BaseUrl;
// } else if (process.env.NODE_ENV == "production") {
//     axios.defaults.baseURL = BaseUrl;
// }
// axios.defaults.baseURL = 'http://xinmeiti.w.bronet.cn/api/';
// axios.defaults.headers.post["Content-Type"] =
//     "application/json";
// axios.defaults.headers.post['XX-Token'] = '';

// 设置请求超时
axios.defaults.timeout = 900000;
// 请求拦截
// 先导入vuex,因为我们要使用到里面的状态对象
// vuex的路径根据自己的路径去写
// import store from '@/store/index';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断vuex中是否存在token
        // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        // const token = store.state.token;
        // const token = localStorage.getItem("token");
        // token && (config.headers.authToken = token);
        // token && (config.headers.Authorization = "Bearer "+ token);
        return config;
    },
    error => {
        return Promise.error(error);
    }
);
var loginExpiredPromptShown = false; // 全局变量 初始化提示标志为false
// 响应拦截器
axios.interceptors.response.use(
    response => {
        NProgress.done();
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        const thisCode = response.data.resultCode !== undefined ? response.data.resultCode : response.data.ResultCode;
        const thisCodeMsg = response.data.resultMsg !== undefined ? response.data.resultMsg : response.data.ResultMsg;
        if(thisCode === 1||thisCode === 4){
            return Promise.resolve(response);
        }else if(response.data.code === 204){
            this.$router.go(0)
        }else if(thisCode === 0 || thisCode === 2){
            swal({
                type:"error",
                text:thisCodeMsg
            })
            return Promise.resolve(response);
        }else if(thisCode === 3){
            Message.error({
                title: "错误",
                message: thisCodeMsg,
                duration: 1500
            });
            router.push({path: "/login"});
        }else if(thisCode === 5){
            if(!loginExpiredPromptShown){
                loginExpiredPromptShown = true;
                Message.error({
                    title: "错误",
                    message: thisCodeMsg,
                    duration: 1500
                });
            }else{
                loginExpiredPromptShown = false;
            }
            router.push({path: "/login"});
            return Promise.reject(new Error(thisCodeMsg));
        }else{
            switch (response.data.code) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 500:
                    Message.error({
                        title: "错误",
                        message: response.data.message,
                        duration: 1500
                    });
                    router.push({path: "/login"});
                    break;

                default:   
                    Message.error({
                        title: "错误",
                        message: thisCodeMsg,
                        duration: 1500
                    });
            }
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        NProgress.done();
        if (error.response.status) {
            Message.error({
                title: "错误",
                message: error.message,
                duration: 1500
            });
            return Promise.reject(error.response);
        }
    }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params,otherBaseUrl,apiVersionType) {
    NProgress.start();
    let newUrl;
    const UID = cookie.get('OperatorId');
    let headers = '';
    if(otherBaseUrl){
        newUrl = url;
        headers = {
            "Content-Type": "application/json;",
            "api-version": apiVersionType ? apiVersionType : '1.0',
            // "Authorization": "Bearer "+ localStorage.token,
            'userkey': localStorage.getItem('userkey'),
            'userid': localStorage.getItem('Id'),
            'appid': 'back',
        }
    }else{
        newUrl = BaseUrlOld + url;
        headers = {
            "Content-Type": "application/json;",
            // "authToken": localStorage.token
        }
    }
    if (newUrl == localStorage.api2cs+'/api/user/login'){
         return new Promise((resolve, reject) => {
             axios
                 .get(newUrl, {
                     params: params
                 })
                 .then(res => {
                    resolve(res.data.ResultObj);
                 })
                 .catch(err => {
                     reject(err.data);
                 });
         });
    }else{
        if (UID != null && UID != 'null' && UID) {
            return new Promise((resolve, reject) => {
                axios
                    .get(newUrl, {
                        params: params,
                        headers
                    })
                    .then(res => {
                        resolve(res.data);
                    })
                    .catch(err => {
                        reject(err.data);
                    });
            });
        } else {
            MessageBox({
                title: '提示',
                message: '登录已失效，即将跳转到登录页面！',
                showConfirmButton: true,
                showCancelButton: false,
                showClose: false,
                closeOnHashChange: true,
                beforeClose: (action, instance, done) => {
                    done(); // 就是它!
                },
                callback: function (action, instance){
                    if(action=='confirm'){
                        router.replace({
                            path: "/login"
                        });
                    }
                }
            })

            setTimeout(() => {
                MessageBox.close()
                router.replace({
                    path: "/login"
                });
            }, 2000);
        }
    }
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Boolean} otherBaseUrl [是否采用其他的域名地址] 1
 **/

export function post(urlPath, params, headers,otherBaseUrl,apiVersionType) {
    if(headers == undefined) {
        let thisuserkey = localStorage.getItem('userkey');
        let thisId = localStorage.getItem('Id');
        headers = {
            "Content-Type": "application/json;",
            'Cache-Control': 'no-cache',
            "api-version": apiVersionType ? apiVersionType : '1.0',
            // "Authorization": "Bearer "+ localStorage.token,
            'userkey': thisuserkey,
            'userid': thisId,
            'appid': 'back',
        }
    }else if(headers == 'formdata') {
        let thisuserkey = localStorage.getItem('userkey');
        let thisId = localStorage.getItem('Id');
        headers = {
            "Content-Type": "multipart/form-data;",
            'Cache-Control': 'no-cache',
            "api-version": apiVersionType ? apiVersionType : '1.0',
            // "Authorization": "Bearer "+ localStorage.token,
            'userkey': thisuserkey,
            'userid': thisId,
            'appid': 'back',
        }
    }else{
        if(urlPath == localStorage.api2cs+'/api/user/login'){
            // 不处理
        }else{
            let thisuserkey = localStorage.getItem('userkey');
            let thisId = localStorage.getItem('Id');
            headers = {
                "Content-Type": "application/json;",
                'Cache-Control': 'no-cache',
                "api-version": apiVersionType ? apiVersionType : '1.0',
                // "Authorization": "Bearer "+ localStorage.token,
                'userkey': thisuserkey,
                'userid': thisId,
                'appid': 'back',
            }
        }
    }
    NProgress.start();
    let url;
    const UID = cookie.get('OperatorId');
    var p = ''
    if (headers['Content-Type'] === 'application/json;') {
        p = params
    } else if(headers['Content-Type'] === 'multipart/form-data;') {
        const formObj = new FormData();
        Object.keys(params).map((key) => {
            formObj.append(key, params[key]);
        });
        p = formObj
    } else {
        p = qs.stringify(Object.assign({}, params))
    }
    if(otherBaseUrl){
        url = urlPath;
    }else{
        url = BaseUrlOld + urlPath;
    }
    if (urlPath == localStorage.api2cs+'/api/user/login'||
        localStorage.api2cs+'/api/account/sendLoginCode'||
        localStorage.api2cs+'/api/user/loginbycode') {
        return new Promise((resolve, reject) => {
            axios
                .post(url, p, {headers})
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data);
                });
        });
    }else{
        if (UID != null && UID != 'null' && UID) {
            return new Promise((resolve, reject) => {
                axios
                    .post(url, p, {headers})
                    .then(res => {
                        resolve(res.data);
                    })
                    .catch(err => {
                        reject(err.data);
                    });
            });
        } else {
            MessageBox({
                title: '提示',
                message: '登录已失效，即将跳转到登录页面！',
                showConfirmButton: true,
                showCancelButton: false,
                showClose: false,
                closeOnHashChange: false,
                beforeClose: (action, instance, done) => {
                    done(); // 就是它!
                },
                callback: function (action, instance) {
                    if (action == 'confirm') {
                        router.push({
                            path: "/login"
                        });
                    }
                }
            })
            setTimeout(() => {
                MessageBox.close()
                router.push({
                    path: "/login"
                });
            }, 2000);
        }
    }
}

export function put(urlPath, params, headers,otherBaseUrl,apiVersionType) {
    if(headers == undefined) {
        let thisuserkey = localStorage.getItem('userkey');
        let thisId = localStorage.getItem('Id');
        headers = {
            "Content-Type": "application/json;",
            'Cache-Control': 'no-cache',
            "api-version": apiVersionType ? apiVersionType : '1.0',
            // "Authorization": "Bearer "+ localStorage.token,
            'userkey': thisuserkey,
            'userid': thisId,
            'appid': 'back',
        }
    }else{
        if(urlPath == localStorage.api2cs+'/api/user/login'){

        }else{
            let thisuserkey = localStorage.getItem('userkey');
            let thisId = localStorage.getItem('Id');
            headers = {
                "Content-Type": "application/json;",
                'Cache-Control': 'no-cache',
                "api-version": apiVersionType ? apiVersionType : '1.0',
                // "Authorization": "Bearer "+ localStorage.token,
                'userkey': thisuserkey,
                'userid': thisId,
                'appid': 'back',
            }
        }
    }
    NProgress.start();
    let url;
    const UID = cookie.get('OperatorId');
    var p = ''
    if (headers['Content-Type'] === 'application/json;') {
        p = params
    } else {
        p = qs.stringify(Object.assign({}, params))
    }
    // headers['api-version'] = apiVersionType ? apiVersionType : '1.0'
    if(otherBaseUrl){
        p = params; // json
        url = urlPath;
        headers={
            headers
        }
    }else{
        url = BaseUrlOld + urlPath;
        headers=headers
    }
    if (urlPath == localStorage.api2cs+'/api/user/login') {
        return new Promise((resolve, reject) => {
            axios
                .put(url, p, headers)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data);
                });
        });
    }else{
        if (UID != null && UID != 'null' && UID) {
            return new Promise((resolve, reject) => {
                axios
                    .put(url, p, headers)
                    .then(res => {
                        resolve(res.data);
                    })
                    .catch(err => {
                        reject(err.data);
                    });
            });
        } else {
            MessageBox({
                title: '提示',
                message: '登录已失效，即将跳转到登录页面！',
                showConfirmButton: true,
                showCancelButton: false,
                showClose: false,
                closeOnHashChange: false,
                beforeClose: (action, instance, done) => {
                    done(); // 就是它!
                },
                callback: function (action, instance) {
                    if (action == 'confirm') {
                        router.push({
                            path: "/login"
                        });
                    }
                }
            })
            setTimeout(() => {
                MessageBox.close()
                router.push({
                    path: "/login"
                });
            }, 2000);
        }
    }
}

export function del(url, params,otherBaseUrl,apiVersionType) {
    NProgress.start();
    let newUrl;
    const UID = cookie.get('OperatorId');
    let headers = '';
    if(otherBaseUrl){
        newUrl = url;
        let thisuserkey = localStorage.getItem('userkey');
        let thisId = localStorage.getItem('Id');
        headers = {
            "Content-Type": "application/json;",
            "api-version": apiVersionType ? apiVersionType : '1.0',
            // "Authorization": "Bearer "+ localStorage.token,
            'userkey': thisuserkey,
            'userid': thisId,
            'appid': 'back',
        }
    }else{
        newUrl = BaseUrlOld + url;
        headers = {
            "Content-Type": "application/json;",
            // "authToken": localStorage.token
        }
    }
    if (UID != null && UID != 'null' && UID) {
        return new Promise((resolve, reject) => {
            axios
                .delete(newUrl, {
                    data: params,
                    headers
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data);
                });
        });
    }
}

export function uploadFile(url, params) {
    let config = {
        headers: {
            // 'authToken': localStorage.token
        }
    };

    return new Promise((resolve, reject) => {
        axios.post(url, params, config)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
            });

    });

}

export function toast(message, type) {
    //上传图片的方法
    if (type == "error") {
        Message.error({
            title: "错误",
            message: message,
            duration: 1500
        });
    } else {
        Message.success({
            title: "提示",
            message: message,
            duration: 1500
        });
    }
}

//导出excel表格
export function download(url, params) {
        //上传图片的方法
    let baseUrl = BaseUrl + url + '?';
    let tempPrams = {};
    for (var obj of params) {
        baseUrl = baseUrl + obj.name + '=' + obj.value + '&'
    }
    window.open(baseUrl) 
}

// 封装导出Excel文件请求
export function exportExcel(url, params, headers) {
    var query = new URLSearchParams();
    for(var item in params){
        query.append(item,params[item])
    }
    var xhr = new XMLHttpRequest();
    //GET请求,请求路径url,async(是否异步)
    xhr.open('GET', url+'?'+query, true);
    //设置请求头参数的方式,如果没有可忽略此行代码
    xhr.setRequestHeader("Authorization", "Bearer "+ localStorage.token);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("api-version",  headers? headers:"1.0");
    //设置响应类型为 blob
    xhr.responseType = 'blob';
    //关键部分
    xhr.onload = function (e) {
        loading.close();
        //如果请求执行成功
        if (this.status == 200) {
            var blob = this.response;
            var a = document.createElement('a');
            //创键临时url对象
            var url = URL.createObjectURL(blob);
            let fileName = Date.parse(new Date()) + '.xls'
            a.href = url;
            a.download = fileName
            a.click();
            //释放之前创建的URL对象
            window.URL.revokeObjectURL(url);
        }
    };
    loading.open();
    //发送请求
    xhr.send();
}


// WEBPACK FOOTER //
// ./src/api/http.js